/*!
 * SPDX-FileCopyrightText: 2025 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
const INJECTION_KEY_THEME = /* @__PURE__ */ Symbol.for("nc:theme:enforced");
export {
  INJECTION_KEY_THEME as I
};
//# sourceMappingURL=constants.mjs.map
